<div class="error-message">
  {{ errorMessage }}
</div>
